import { GeoTransformers } from '@/common/services/geoTransformers'
import { options as billByOptions } from '@/features/privateCompanyLeadsFunnel/constants/billByOptions.constant'
import { options as billGroupingModeOptions } from '@/features/privateCompanyLeadsFunnel/constants/billGroupingModeOptions.constant'
import { options as cycleOptions } from '@/features/privateCompanyLeadsFunnel/constants/cycleOptions.constant'
import { options as defaultContractCnpjOptions } from '@/features/privateCompanyLeadsFunnel/constants/defaultContractCnpjOptions.constant'
import { options as durationInMonthsOptions } from '@/features/privateCompanyLeadsFunnel/constants/durationInMonthsOptions.constant'
import { options as fiscalDocumentRequirement } from '@/features/privateCompanyLeadsFunnel/constants/fiscalDocumentRequirement.constant'
import { options as monthDaysOptions } from '@/features/privateCompanyLeadsFunnel/constants/monthDaysOptions.constant'
import { options as paymentMethodOptions } from '@/features/privateCompanyLeadsFunnel/constants/paymentMethodOptions.constant'
import { options as weekDaysOptions } from '@/features/privateCompanyLeadsFunnel/constants/weekDaysOptions.constants'
import { PrivateCompanyLeadsFunnelUpdateContractValidationSchema } from '@/features/privateCompanyLeadsFunnel/schemas/update.schema'
import { ContractData } from '@/features/privateCompanyLeadsFunnel/types/privateCompanyLead'

export const updatePrivateCompanyLeadContractDefaultValues = (contract?: ContractData) => {
  const establishmentCompanyBranchDefaultValues: PrivateCompanyLeadsFunnelUpdateContractValidationSchema = {
    contract: {
      duration_in_months: durationInMonthsOptions.find(({ value }) => value === `${contract?.duration_in_months}`),
      cycle: cycleOptions.find(({ value }) => value === contract?.cycle),
      cycle_start_day:
        contract?.cycle === 'weekly'
          ? contract?.cycle_start_day !== null && contract?.cycle_start_day !== undefined
            ? weekDaysOptions[contract?.cycle_start_day]
            : null
          : monthDaysOptions.find(({ value }) => value === `${contract?.cycle_start_day}`),
      closing_to_due_in_days: contract?.closing_to_due_in_days
        ? { label: `D+${contract?.closing_to_due_in_days}`, value: `${contract?.closing_to_due_in_days}` }
        : null,
      due_to_suspension_in_days: contract?.due_to_suspension_in_days
        ? { label: `D+${contract?.due_to_suspension_in_days}`, value: `${contract?.due_to_suspension_in_days}` }
        : null,
      bill_grouping_mode: billGroupingModeOptions.find(({ value }) => value === contract?.bill_grouping_mode),
      bill_by: billByOptions.find(({ value }) => value === contract?.bill_by),
      fiscal_document_requirement: fiscalDocumentRequirement.find(
        ({ value }) => value === contract?.fiscal_document_requirement,
      ),
      cnpj_for_fiscal_document: defaultContractCnpjOptions.find(
        ({ value }) => value === contract?.cnpj_for_fiscal_document,
      ),
      payment_method: paymentMethodOptions.find(({ value }) => value === contract?.payment_method),
      contract_product_categories: contract?.contract_product_categories?.map(({ product_category }) => ({
        label: product_category.display_name,
        value: product_category.id,
      })),
      geo_geoables: GeoTransformers.mapToGeo()(contract?.geo_geoables),
      contract_equipment_categories: contract?.contract_equipment_categories?.map((contractEquipmentCategory) => ({
        id: contractEquipmentCategory.id,
        equipment_category: {
          id: contractEquipmentCategory.equipment_category.id,
          display_name: contractEquipmentCategory.equipment_category.display_name,
        },
        quantity: contractEquipmentCategory.quantity.toString(),
      })),
    },
  }

  return establishmentCompanyBranchDefaultValues
}
